/* Os dados de exemplo da folha, compartilhados pela prévia (FolhaDocumento)
   e pelo editor (a tabela de itens desenhada dentro da folha editável). */

/* Três itens fictícios que somam exatamente o exemplo do catálogo
   ("Valor total dos itens" = R$ 1.250,00, "Quantidade de itens" = 3). Se não
   somassem, a prévia mostraria a tabela com um total e o texto com outro. */
export const ITENS_EXEMPLO = [
    { codigo: 'SRV-01', descricao: 'Implantação', qtd: 1, unit: 450, total: 450 },
    { codigo: 'SRV-02', descricao: 'Mensalidade', qtd: 2, unit: 250, total: 500 },
    { codigo: 'PRD-07', descricao: 'Treinamento da equipe', qtd: 1, unit: 300, total: 300 },
];
export const TOTAL_EXEMPLO = 1250;

/** Larguras das colunas da tabela no gerador (Código, Descrição, Qtd., Unitário, Total); null = o que sobra. */
export const COLUNAS_TABELA: (number | null)[] = [70, null, 40, 85, 85];

export const brl = (v: number) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
